import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
    MarkdownContent,
    Section,
    Typography,
} from 'wanderu-components';

import BlurbSection from './BlurbSection/BlurbSection';

import styles from './EditorialBlurbs.scss';

const MAX_CITY_AND_BLOG_IMAGES = 3;
const MAX_STATION_IMAGES = 3;

function EditorialBlurbs(props) {
    const {
        namespace,
        label,
        title,
        departureSubtitle = '',
        departureImageSubtitle = '',
        departureDescription = '',
        departureStationsSubtitle = '',
        arrivalSubtitle = '',
        arrivalImageSubtitle = '',
        arrivalDescription = '',
        arrivalStationsSubtitle = '',
        variant = 'cities',
        blurbContent,
        showDepartSection = false,
        showArriveSection = false,
    } = props;
    let {
        blogPosts,
        departCityImages,
        arriveCityImages,
        departStationImages,
        arriveStationImages,
        departStations,
        arriveStations,
        moovitTitle,
        moovitDescription,
    } = blurbContent;

    let maxImages = MAX_CITY_AND_BLOG_IMAGES;
    let departImages = departCityImages;
    let arriveImages = arriveCityImages;

    if (variant !== 'stations') {
        departStations = [];
        arriveStations = [];
    }

    if (variant === 'stations') {
        maxImages = MAX_STATION_IMAGES;
        departImages = departStationImages;
        arriveImages = arriveStationImages;
    }

    if (variant === 'blog') {
        departImages = blogPosts;
    }

    const showMoovitSection = variant === 'stations' && !!moovitTitle && !!moovitDescription;

    return (
        <Section aria-labelledby={label}>
            <Typography
                className={styles.header}
                component="h2"
                id={label}
                variant="h3"
            >
                {title}
            </Typography>
            {showDepartSection && (
                <BlurbSection
                    description={departureDescription}
                    imageSubtitle={departureImageSubtitle}
                    images={departImages}
                    maxImages={maxImages}
                    namespace={namespace}
                    stations={departStations}
                    stationsSubtitle={departureStationsSubtitle}
                    subtitle={departureSubtitle}
                />
            )}
            {showArriveSection && (
                <BlurbSection
                    description={arrivalDescription}
                    imageSubtitle={arrivalImageSubtitle}
                    images={arriveImages}
                    maxImages={maxImages}
                    namespace={namespace}
                    stations={arriveStations}
                    stationsSubtitle={arrivalStationsSubtitle}
                    subtitle={arrivalSubtitle}
                    subtitleClass={styles.subtitle}
                />
            )}
            {showMoovitSection && (
                <>
                    <Typography
                        className={classNames(styles.subtitle, styles.moovitHeader)}
                        component="h3"
                        id="moovit"
                        variant="subtitle"
                    >
                        {moovitTitle}
                    </Typography>
                    <Typography
                        component={MarkdownContent}
                        externalLinks
                    >
                        {moovitDescription}
                    </Typography>
                </>
            )}
        </Section>
    );
}

EditorialBlurbs.propTypes = {
    namespace: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    departureSubtitle: PropTypes.string,
    departureImageSubtitle: PropTypes.string,
    departureDescription: PropTypes.string,
    departureStationsSubtitle: PropTypes.string,
    arrivalSubtitle: PropTypes.string,
    arrivalImageSubtitle: PropTypes.string,
    arrivalDescription: PropTypes.string,
    arrivalStationsSubtitle: PropTypes.string,
    showDepartSection: PropTypes.bool,
    showArriveSection: PropTypes.bool,
    blurbContent: PropTypes.shape({
        blogPosts: PropTypes.arrayOf(PropTypes.object),
        departCityImages: PropTypes.arrayOf(PropTypes.object),
        arriveCityImages: PropTypes.arrayOf(PropTypes.object),
        departStationImages: PropTypes.arrayOf(PropTypes.object),
        arriveStationImages: PropTypes.arrayOf(PropTypes.object),
        departStations: PropTypes.arrayOf(PropTypes.object),
        arriveStations: PropTypes.arrayOf(PropTypes.object),
    }),
};

export default EditorialBlurbs;
